import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'

import Pagination from "../../services/Pagination";
import { Table, Form, Button } from 'react-bootstrap'


import ModalNuevoPeriodo from './ModalNuevoPeriodo'

import ModalNuevaActividadProgramada from './ModalNuevaActividadProgramada'


import Dialog from '../../services/Dialogs'


import './periodos.scss'

const Periodos = () =>{

  const dialog = new Dialog();

  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 10
  const [currentPage, setCurrentPage] = useState(1);

  const [ text_busqueda, setTextoBusqueda ] = useState('')

  const [ cargando_, setCargando ] = useState( false )

  const skull = { results: [] }

  const [ resultados, setResultados ] = useState<any>({...skull})

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*sessionsPerPage);
      let response : any = await RequestService.getEndPoint(`periodos/busqueda?where=${text_busqueda}&skip=${skip}&limit=${sessionsPerPage}`)
      setCounter(response.data.totalCount)
      setResultados(response.data.resultados)
      setCargando(false)
    }
    catch(e:any){

      if (e.response?.status) {
        switch (e.response.status) {
          case 404:
            toast.error("Debes escribir algo")
            break;
          default:
            toast.error(e.response?.data)
        }
      }
      else{
        toast.error("Problemas con la busqueda")
      }
      setCargando(false)

    }
  }


  const busqueda = async () =>{
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setCurrentPage(1)
  }

  const [ arreglo_estatus, setEstatus ] = useState<any>([true])


  const todos = () =>{
    setEstatus([true])
  }
  const ninguno = () =>{
    setEstatus([false])
  }


      React.useEffect(() => {
        busqueda()
        cargarConfiguracion()
      }, []);


  const [ configuracion, setConfiguracion ] = useState<any>([])
  const [ envio_server, setSeEnvio ] = useState<boolean>(false)
  const cargarConfiguracion = async()=>{
    try{
      setSeEnvio(true)
      let response : any = await RequestService.getEndPoint(`periodos/configuracion/${selectedOption.id}`)
      setConfiguracion(response.data)
      setSeEnvio(false)
    }
    catch(e){
      setSeEnvio(false)
      toast.error('Problemas al intentar cargar')
    }
  }




  const [ show_ModalNuevoPeriodo, setModalNuevoPeriodo ] = useState<boolean>(false)
  const handleShow_ModalNuevoPeriodo = () => {
    setModalNuevoPeriodo(true)
  }
  const handleClose_ModalNuevoPeriodo = () => {
    setModalNuevoPeriodo(false)
  }

  const handleClose_ModalNuevoPeriodoSuccess = () => {
    window.location.reload()
  }






  const [ show_ModalNuevaActividadProgramada, setModalNuevaActividadProgramada ] = useState<boolean>(false)
  const handleShow_ModalNuevaActividadProgramada = () => {
    setModalNuevaActividadProgramada(true)
  }
  const handleClose_ModalNuevaActividadProgramada = () => {
    setBoutiqueSeleccionada(null)
        cargarConfiguracion()
    setModalNuevaActividadProgramada(false)
  }



  const [ boutique_selected, setBoutiqueSeleccionada ] = useState<any>(null)
  const handleShow_ModalNuevaActividadProgramadaBoutique = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalNuevaActividadProgramada(true)
  }


  const [ fechas_selected, setFechasSelected ] = useState<any>(null)
  const handleShow_ModalNuevaActividadProgramadaBoutiquePorDia = (boutique:any,fecha:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalNuevaActividadProgramada(true)
  }





const obtenerFechasEnRango = (inicio:any, fin:any) => {
  const fechas = [];
  let fechaActual = new Date(inicio);
  const fechaFin = new Date(fin);

  // Iterar mientras la fecha actual no sea mayor a la fecha de fin
  while (fechaActual <= fechaFin) {
    // Formateamos la fecha en formato YYYY-MM-DD
    const fechaFormateada = fechaActual.toISOString().split('T')[0];
    fechas.push(fechaFormateada);
    
    // Sumamos un día
    fechaActual.setDate(fechaActual.getDate() + 1);
  }

  return fechas;
}


const filtrarPorFecha = (fecha:any, arreglo:any) => {
  // Convertimos la fecha ingresada a un objeto Date
  const fechaBuscada = new Date(fecha);
  // Filtramos el arreglo buscando coincidencias con la fecha proporcionada
  return arreglo.filter((item:any) => {
    // Comparamos solo la parte de la fecha (sin considerar la hora)
    const fechaItem = new Date(item.fecha_programada);
    return fechaItem.toISOString().split('T')[0] === fechaBuscada.toISOString().split('T')[0];
  });
}




const publicarAlCliente = async(event:any) => {
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.update( `periodo/publicar_clientes` , {} )

          if(res_){
            toast.success('El Calendario fué publicado para el Cliente')
            setTimeout(()=>{
              cargarConfiguracion()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
          } 
          
        }
       
  }




const publicarPeriodo = async(event:any) => {
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.update( `periodo/publicar_periodo` , {} )

          if(res_){
            toast.success('El Periodo fué publicado')
            setTimeout(()=>{
              cargarConfiguracion()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
          } 
          
        }
       
  }





  const [selectedOption, setSelectedOption] = useState<any>({ id: 1, tipo_orden: 'MANTENIMIENTO' });

  // Opciones para los botones de radio
  const opciones = [
    { id: 1, tipo_orden: 'MANTENIMIENTO' },
    { id: 4, tipo_orden: 'CONSERVACIÓN' },
    { id: 7, tipo_orden: 'SERVICIO DE LIMPIEZA' },
  ];

  // Manejador para actualizar el estado cuando se selecciona una opción
  const handleChange = (value:any) => {
    setSelectedOption(value);
  };


  React.useEffect(() => {
    if (selectedOption) {
      cargarConfiguracion();
    }
  }, [selectedOption]); // Dependencia en selectedOption




      return (
          <>
            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-10 col-sm-11">

                    <h4>Configuración de Periodos</h4>
                    <hr/>
                    
                    <div className="row">
                      <div className="col-2">



                          {  (!cargando_) && (

                              <>

                                   {
                                     resultados.length > 0 && (

                                       <>


                                       <h5>Periodos</h5>


                                        <Table responsive="lg">
                                          <thead>
                                            <tr>
                                              <th scope="col"></th>
                                              <th scope="col"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              resultados.map( (cual:any,indice:number) =>
                                                  <tr key={indice} style={{fontSize:12}}>
                                                    <td className="v text-left" style={{"width":"160px"}}>
                                                        <p className="nm"><small><b>{moment(cual.fecha_inicio).format('DD/MMM/YYYY').replace('.','').toUpperCase()}</b></small></p>
                                                    </td>
                                                    <td className="v text-left" >
                                                        <p className="nm"><small><b>{moment(cual.fecha_fin).format('DD/MMM/YYYY').replace('.','').toUpperCase()}</b></small></p>
                                                    </td>
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}




      <h6 className="mt-4">Tipo de Calendario:</h6>
      <div className="form-check">
        {opciones.map((opcion) => (
          <div key={opcion.id} className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="tipoOrden"
              id={`tipoOrden${opcion.id}`}
              checked={selectedOption.id === opcion.id}
              onChange={(e:any)=>{ handleChange(opcion); cargarConfiguracion(); }}
            />
            <label className="form-check-label" htmlFor={`tipoOrden${opcion.id}`}>
              {opcion.tipo_orden}
            </label>
          </div>
        ))}
      </div>

      {
        // (selectedOption)
      }




                      </div>
                      <div className="col-10">

                        <div className="row">
                          <div className="col">
                            
                            <h6>Periodo Actual</h6>

                            <h3>DEL {moment(configuracion.actual?.fecha_inicio).format('DD [DE] MMM [DE] YYYY').replace('.','').toUpperCase()} AL {moment(configuracion.actual?.fecha_fin).format('DD [DE] MMM [DE] YYYY').replace('.','').toUpperCase()}</h3>

                          </div>
                          <div className="col">
                            
                            <h6>Periodo en Configuración</h6>

                            {
                              configuracion.programacion && (
                                  <>
                                      <h3>DEL {moment(configuracion.programacion?.fecha_inicio).format('DD [DE] MMM [DE] YYYY').replace('.','').toUpperCase()} AL {moment(configuracion.programacion?.fecha_fin).format('DD [DE] MMM [DE] YYYY').replace('.','').toUpperCase()}</h3>
                                  </>
                                )
                            }

                            {
                              !configuracion.programacion && (
                                    <Button variant="primary" className="w-100" onClick={handleShow_ModalNuevoPeriodo}>Crear Nuevo Periodo</Button>
                                )
                            }


                          </div>
                        </div>


                            {
                              configuracion.programacion && (
                                  <React.Fragment>
                                    <div className="row">
                                      <div className="col">
                                          <Button variant="info" className="w-100 mt-2" onClick={handleShow_ModalNuevaActividadProgramada}>Programar Visitas</Button>
                                      </div>
                                      <div className="col">

                                          {
                                            configuracion.programacion?.estatus === 'PROGRAMACION' && (
                                                  <Button variant="orange" className="w-100 mt-2" onClick={publicarAlCliente}>Mostrar la programación al Cliente</Button>
                                              )
                                          }

                                          {
                                            configuracion.programacion?.estatus === 'PREVIEW_CLIENTE' && (
                                                  <Button variant="primary" className="w-100 mt-2" onClick={publicarPeriodo}>Publicar el Periodo</Button>
                                              )
                                          }



                                      </div>
                                    </div>






                                    {
                                      configuracion.calendario_programacion.map( (area:any,indice_area:number) =>

                                          <React.Fragment key={indice_area}>

                                            <h3 className="mt-4">{area.area}</h3>

                                            {
                                              // JSON.stringify(area)
                                            }


                                            {
                                              area.sub_areas.map((sub_area:any,indice_sub_area:number)=>

                                                  <React.Fragment key={indice_sub_area}>
                                                    {
                                                      // JSON.stringify(sub_area)
                                                    }
                                                    <h5>{sub_area.subarea}</h5>


                                                    {/*<br/>*/}

                                                    <div className="overflow-auto mb-4">
                                                      <table className="table table-sm tablon" style={{ tableLayout: 'fixed' }}>
                                                        <thead>
                                                          <tr>
                                                            <th scope="col" className="sticky-column" style={{ width: '350px', background: 'white' }}>Boutique</th>
                                                            <th scope="col" className="sticky-column text-center pointer" onClick={handleShow_ModalNuevaActividadProgramada} style={{ width: '50px', background: 'white' }}>📋</th>
                                                            {
                                                              obtenerFechasEnRango(configuracion.programacion?.fecha_inicio, configuracion.programacion?.fecha_fin).map((fecha: any, indice_fecha: number) =>
                                                                <th className="v text-center" style={{ width: '140px' }}>
                                                                  <small>{moment(fecha).format('DD/MMM/YYYY').replace('.','').toUpperCase()} {moment(fecha).format('ddd').replace('.','').toUpperCase()}</small>
                                                                </th>
                                                              )
                                                            }
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {
                                                            sub_area.boutiques.map((boutique: any, indice_boutique: number) =>
                                                              <>
                                                                <tr>
                                                                  <td className="v sticky-column" style={{ width: '350px', background: 'white' }}>
                                                                    <p className="nm">{boutique.nombre_boutique}</p>
                                                                  </td>
                                                                  <td className="v sticky-column text-center pointer" onClick={(e:any)=>{handleShow_ModalNuevaActividadProgramadaBoutique(boutique)}} style={{ width: '50px', background: 'white' }}>
                                                                    <p className="nm"><small><b>{boutique.visitas.length}</b></small></p>
                                                                  </td>
                                                                  {
                                                                    obtenerFechasEnRango(configuracion.programacion?.fecha_inicio, configuracion.programacion?.fecha_fin).map((fecha: any, indice_fecha: number) =>
                                                                      <td className={`v text-center ${ filtrarPorFecha(fecha, boutique.visitas).length > 0 ? `tipo_orden_${selectedOption.id}` : '' }`} onClick={(e:any)=>{handleShow_ModalNuevaActividadProgramadaBoutiquePorDia(boutique, fecha)}} style={{
                                                                        width: '140px',
                                                                        background: `${filtrarPorFecha(fecha, boutique.visitas).length === 0 ? '#e9e9e952' : ''}`,
                                                                      }}>
                                                                        {
                                                                          filtrarPorFecha(fecha, boutique.visitas).map((visita: any, indice_visita: number) =>
                                                                            <p className="nm" style={{ fontSize: 11 }}>
                                                                              <small>{visita.tecnico?.nombres}</small>
                                                                            </p>
                                                                          )
                                                                        }
                                                                      </td>
                                                                    )
                                                                  }
                                                                </tr>
                                                              </>
                                                            )
                                                          }
                                                        </tbody>
                                                      </table>
                                                    </div>






{
  // JSON.stringify(obtenerFechasEnRango(configuracion.programacion?.fecha_inicio,configuracion.programacion?.fecha_fin))
}

                                                  </React.Fragment>

                                                )
                                            }


                                            <br/>
                                            <br/>
                                            <br/>

                                          </React.Fragment>

                                      )
                                    }



                                    {
                                      // JSON.stringify(configuracion.calendario_programacion)
                                    }





















                                  </React.Fragment>
                                )
                            }

                        {
                          // JSON.stringify(configuracion)
                        }




                      </div>
                    </div>

                </div>
              </div>

            </div>




            {
              show_ModalNuevoPeriodo && (
                <ModalNuevoPeriodo show={show_ModalNuevoPeriodo} handleClose={handleClose_ModalNuevoPeriodo} handleCloseSuccess={handleClose_ModalNuevoPeriodoSuccess} periodo_actual={configuracion.actual} />
                )

            }





            {
              show_ModalNuevaActividadProgramada && (
                <ModalNuevaActividadProgramada show={show_ModalNuevaActividadProgramada} handleClose={handleClose_ModalNuevaActividadProgramada} periodo_programacion={configuracion.programacion} boutique={boutique_selected} tipo_orden={selectedOption} />
                )

            }


          </>

      );
  

}

export default Periodos
